import { createTheme, type Theme } from "@mui/material/styles";
import { BRAND, darkPalette, lightPalette } from "./tokens";
import { typography } from "./typography";
import { components } from "./components";

export interface Branding {
  primaryColor?: string | null;
  accentColor?: string | null;
}

/**
 * Build the app theme with both colour schemes. `branding` (from `/api/branding`)
 * overrides the brand palette entries; everything else is fixed. Rebuild and
 * re-provide when branding loads — MUI's CSS variables make the swap seamless.
 */
export function buildTheme(branding?: Branding): Theme {
  const primary = colorOr(branding?.primaryColor, BRAND.primary);
  const secondary = colorOr(branding?.accentColor, BRAND.secondary);

  return createTheme({
    cssVariables: { colorSchemeSelector: "class" },
    colorSchemes: {
      light: { palette: lightPalette(primary, secondary) },
      dark: { palette: darkPalette(primary, secondary) },
    },
    shape: { borderRadius: 10 },
    typography,
    components,
  });
}

const HEX = /^#(?:[\da-f]{3}|[\da-f]{6})$/i;
function colorOr(value: string | null | undefined, fallback: string): string {
  return value && HEX.test(value.trim()) ? value.trim() : fallback;
}
